import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=70a308a8"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70a308a8')) {
      api.createRecord('70a308a8', component.options)
    } else {
      api.reload('70a308a8', component.options)
    }
    module.hot.accept("./Banner.vue?vue&type=template&id=70a308a8", function () {
      api.rerender('70a308a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/inc/Banner.vue"
export default component.exports